import React from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'
import Spinner from './spinner'

const ContainerDiv = styled.div`
  position: absolute;
  bottom: 30px;
  left: 50%;
  color: ${colours.lightPurple};
`

interface IProps {
  visible: boolean
}

class MapLoadingSpinner extends React.Component<IProps> {
  render() {
    if (this.props.visible) {
      return (
        <ContainerDiv>
          <Spinner />
        </ContainerDiv>
      )
    } else {
      return <ContainerDiv />
    }
  }
}

export default MapLoadingSpinner
